import { Tender, TenderLine } from '$models'
import { TenderLineUi, TenderUi } from '../types'

export function convertTenderToTenderUi(tender: Tender): TenderUi {
  return Object.assign({}, tender, {
    lines: (tender.lines ?? []).map((line) => ({
      ...line,
      lineId: crypto.randomUUID(),
      unitId: line.unitId ?? '',
      unitName: line.unitName ?? '',
      unitRatio: line.unitRatio ?? 1,
      brandId: line.brandId ?? '',
      brandName: line.brandName ?? '',
    })),
  }) as TenderUi
}

/** Convert empty strings to undefined so empty Guids serialize as null */
const emptyToUndefined = (val?: string): string | undefined => val || undefined

export function convertTenderUiToTender(tenderUi: TenderUi): Tender {
  return Object.assign({}, tenderUi, {
    lines: tenderUi.lines.map(
      ({ lineId: _lineId, lastLine: _lastLine, ...rest }: TenderLineUi) =>
        new TenderLine({
          ...rest,
          tenderId: tenderUi.id,
          id: emptyToUndefined(rest.id),
          brandId: emptyToUndefined(rest.brandId),
          unitId: emptyToUndefined(rest.unitId),
        })
    ),
  }) as Tender
}
